export const EXTERNAL_INTEGRATION = {
    HUBRISE: 'hubrise',
    SPLASH: 'splash'
    }
